import React from 'react';
import { Box, Alert, Button } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { ChecklistHeader } from './ChecklistHeader';

type ChecklistErrorStateProps = {
  error: Error;
  itemCount: number;
  onRefresh: () => void;
};

export const ChecklistErrorState: React.FC<ChecklistErrorStateProps> = ({
  error,
  itemCount,
  onRefresh
}) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        backgroundColor: 'background.default'
      }}
    >
      <ChecklistHeader
        itemCount={itemCount}
        hasUnsavedChanges={false}
        isSaving={false}
        onAddItem={() => {}}
        onSave={() => {}}
        onDiscard={() => {}}
      />

      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
          padding: { xs: 2, sm: 3, md: 4 }
        }}
      >
        <Box
          sx={{
            maxWidth: 800,
            margin: '0 auto'
          }}
        >
          <Alert severity="error" sx={{ mb: 2 }}>
            {t('checklist:error.loadFailed')}: {error.message}
          </Alert>
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={onRefresh}
          >
            {t('checklist:error.retry')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
